export const muvi = {
  hero: {
    title1: 'MuVi Space',
    title2: 'Create.',
    title3: 'Record.',
    title4: 'Broadcast.',
    subtitle: 'Podcast, Live Streaming, Casting, Brand Interviews & Short Video Production Space',
    cta: 'Book Now',
  },
  features: {
    title: 'Space Features',
    subtitle: 'Start creating with just your phone or camera',
    podcast: { title: 'Podcast Recording', desc: 'Professionally soundproofed space with multi-track recording, suitable for duo conversations or roundtable formats.' },
    livestream: { title: 'Live Streaming', desc: 'Stable high-speed internet with multi-camera switching equipment, supporting all major streaming platforms.' },
    casting: { title: 'Casting Space', desc: 'Private audition area with professional lighting and monitoring systems, ideal for actor casting and screen tests.' },
    productShooting: { title: 'Product Shooting', desc: 'Spacious infinity wall and turntable photography setup, perfect for all types of product and e-commerce content creation.' },
    interview: { title: 'Brand Interviews', desc: 'Comfortable interview set with a blend of natural and professional lighting to craft compelling brand videos.' },
    workshop: { title: 'Workshop / Seminar', desc: 'Flexible space for 15-20 people, ideal for small lectures, workshops and training sessions.' },
  },
  gallery: {
    title: 'Venue Gallery',
    subtitle: 'Versatile scenes, ready to transform',
    podcast: 'Podcast Studio',
    livestream: 'Live Streaming Room',
    productShooting: 'Product Photography Area',
    interview: 'Interview Space',
    workshop: 'Workshop Area',
    casting: 'Casting Zone',
  },
  equipment: {
    title: 'Equipment & Services',
    subtitle: 'Equipment is confirmed by project need and may combine in-house and rental resources',
    microphone: { title: 'Pro Microphones', desc: 'Primarily RØDE, Shure and comparable professional microphones; actual models and quantities are confirmed per booking.' },
    lighting: { title: 'Lighting System', desc: 'Primarily Aputure, Godox, SIRUI and comparable production lights with modifiers confirmed by scene needs.' },
    liveStreaming: { title: 'Live Streaming Gear', desc: 'Live switching equipment is primarily CINETREAK CineTreak C2 or ATEM, with setup and availability confirmed per project.' },
    tripod: { title: 'Tripods & Stabilizers', desc: 'Manfrotto professional tripods, DJI stabilizers for smooth and steady footage.' },
    monitor: { title: 'Monitor Screens', desc: 'Multiple preview monitors so directors and clients can check framing and lighting in real time.' },
    switcher: { title: 'Switcher / Control Equipment', desc: 'Switcher and control equipment is primarily CINETREAK CineTreak C2 or ATEM; actual model, quantity and operator needs are confirmed per booking.' },
  },
  pricing: {
    title: 'Pricing Plans',
    subtitle: 'Transparent pricing, no hidden fees',
    venue: 'Venue Fee',
    venuePrice: 'NT$500 / hour',
    venueDesc: 'Includes basic lighting, air conditioning, Wi-Fi',
    techSupport: 'Technical Support',
    techPrice: 'NT$200 / hour',
    techDesc: 'On-site professional technician assistance',
    note: 'Minimum 2-hour booking',
  },
  faq: {
    title: 'FAQ',
    subtitle: 'Common questions about MuVi Space',
    q1: 'Is parking available?',
    a1: 'MuVi Space is located inside LensBank. Paid parking lots and street parking are available nearby. Temporary loading/unloading is allowed at the entrance.',
    q2: 'Is Wi-Fi provided?',
    a2: 'The venue offers high-speed fiber optic Wi-Fi with upload/download speeds exceeding 300Mbps, ensuring stable streaming and file transfers.',
    q3: 'Can I use the space late at night?',
    a3: 'MuVi Space standard hours are 09:00 - 22:00. Late-night requests can be noted during booking and will be arranged case by case; additional fees may apply.',
    q4: 'Can I bring my own equipment?',
    a4: 'Absolutely! Feel free to bring your own cameras, lights or audio gear. We also offer full equipment rental services to complement your setup.',
    q5: 'How far in advance should I book?',
    a5: 'We recommend booking at least 3 business days in advance to ensure venue and staff availability. Urgent requests are welcome via phone.',
    q6: 'Can I cancel or modify my booking?',
    a6: 'Changes or cancellations should be made at least 48 hours before the booking date. Same-day cancellations will incur a 50% fee.',
    q7: 'How many people can the venue accommodate?',
    a7: 'MuVi Space is approximately 20 ping (66 sqm), suitable for 2-15 person production teams. For larger spaces or special set requirements, please discuss with us in advance.',
    q8: 'Is catering available?',
    a8: 'A pantry with coffee, tea and bottled water is provided. We can also assist with food delivery or catering orders.',
  },
  booking: {
    title: 'Book MuVi Space',
    subtitle: 'Fill out the form below and we\'ll confirm with you shortly',
    formTitle: 'Booking Request Form',
    companyName: 'Company Name',
    companyNamePlaceholder: 'Enter your company or organization name',
    contactName: 'Contact Person',
    contactNamePlaceholder: 'Enter contact name',
    phone: 'Phone',
    phonePlaceholder: 'e.g. +886-912-345-678',
    email: 'Email',
    emailPlaceholder: 'example@company.com',
    activityType: 'Activity Type',
    activityTypePlaceholder: 'Select activity type',
    date: 'Preferred Date',
    startTime: 'Start Time',
    endTime: 'End Time',
    needTechSupport: 'Need Technical Support?',
    needTechSupportYes: 'Yes (+NT$200/hr)',
    needTechSupportNo: 'No',
    notes: 'Notes',
    notesPlaceholder: 'Describe any special requirements here, e.g. needed equipment, setup preferences...',
    notesMaxChars: 'Max 500 characters',
    pricingSummary: 'Estimated Cost',
    venueFee: 'Venue Fee',
    techFee: 'Technical Support Fee',
    hours: 'hrs',
    total: 'Total',
    submitButton: 'Submit Booking Request',
    submitting: 'Submitting...',
    noticeTitle: 'Important Notice',
    noticeText: 'Submission is a booking request only. Confirmation is subject to MuVi Space venue and staff availability. We\'ll contact you within 1-2 business days.',
    required: '*',
    successTitle: 'Booking Request Submitted',
    successMessage: 'Thank you for your booking! We\'ll contact you shortly to confirm venue and staff availability.',
    backToHome: 'Back to MuVi Space',
  },
  activityTypes: {
    podcast: 'Podcast Recording',
    livestream: 'Live Streaming',
    casting: 'Casting',
    brandInterview: 'Brand Interview',
    productShooting: 'Product Shooting',
    courseRecording: 'Course Recording',
    other: 'Other',
  },
  admin: {
    bookings: {
      title: 'MuVi Space Booking Management',
      subtitle: 'View and manage all MuVi Space booking requests',
      bookingId: 'Booking ID',
      customer: 'Customer',
      date: 'Date',
      time: 'Time',
      activityType: 'Activity Type',
      estimatedAmount: 'Est. Amount',
      status: 'Status',
      detail: 'View Details',
      history: 'History',
      notes: 'Notes',
      statusPending: 'Pending',
      statusStaffingReview: 'Staffing Review',
      statusConfirmed: 'Confirmed',
      statusRejected: 'Rejected',
      statusCancelled: 'Cancelled',
      mockBanner: 'Mock data — Database not connected',
    },
    content: {
      title: 'MuVi Space Content Management',
      subtitle: 'Manage frontend content, images, and section settings',
      hero: 'Hero Section',
      heroDesc: 'Manage hero background images',
      gallery: 'Venue Photo Management',
      galleryDesc: 'Manage venue photo carousel',
      equipmentImages: 'Equipment Image Management',
      equipmentImagesDesc: 'Manage equipment & services section images',
      features: 'Feature Block Management',
      featuresDesc: 'Manage feature card content and ordering',
      faq: 'FAQ Management',
      faqDesc: 'Manage FAQ content',
      mockBanner: 'Mock data — Database not connected',
      save: 'Save Changes',
      saved: 'Saved',
      addImage: 'Add Image',
      uploadImage: 'Upload Image',
      imageUrl: 'Image URL',
      altText: 'Alt Text',
      sortOrder: 'Sort Order',
      active: 'Active',
      inactive: 'Inactive',
      delete: 'Delete',
      maxImages: 'Max 6 images per section',
    },
    settings: {
      title: 'MuVi Space Settings',
      subtitle: 'Manage booking-related settings and contact information',
      venueHourlyRate: 'Venue Hourly Rate (NT$)',
      techHourlyRate: 'Tech Staff Hourly Rate (NT$)',
      bookingNotice: 'Booking Notice Text',
      bookingNoticePlaceholder: 'Enter notice text displayed on the booking page...',
      contactPhone: 'Contact Phone',
      contactEmail: 'Contact Email',
      googleMapEmbed: 'Google Maps Embed URL',
      googleMapPlaceholder: 'Paste Google Maps embed iframe URL...',
      saveSettings: 'Save Settings',
      saved: 'Settings Saved',
      mockBanner: 'Mock data — Database not connected',
    },
  },
};
